import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const sbb_icon: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill={iconColor}
        stroke={"none"}
        d="M 1.4642858,12.185585 6.8717954,6.4285714 H 10.1163 L 5.7902936,11.034183 H 10.927426
        V 6.4285714 h 2.163004 v 4.6056116 h 5.137135 L 13.901557,6.4285714 h 3.244506 l 5.407508,
        5.7570136 -5.407508,5.757014 h -3.244506 l 4.326008,-4.605611 H 13.09043 v 4.605611 H
        10.927426 V 13.336988 H 5.7902936 L 10.1163,17.942599 H 6.8717954 Z"
      />
    </svg>
  );
};
